import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import { runBulk } from "routes/schedule/my-schedules/my-custom-schedules/bulk-runner"
import { deleteDraft } from "routes/schedule/edit/delete-button"
import { CustomScheduleActions } from "./selection-actions-slot-definitions"
import { clearGlobal, succeeded } from "./selection-actions-helpers"

CustomScheduleActions.plug(<DeleteDraftsButton if={({ draftItems = [] }) => draftItems.length} priority={20} />)

export function DeleteDraftsButton() {
    const { draftItems = [] } = useBoundContext()

    return (
        <Button
            size="small"
            color="error"
            startIcon={<Iconify icon="gravity-ui:trash-bin" />}
            onClick={deleteDrafts}
            data-cy="bulk-delete-drafts"
        >
            Delete {draftItems.length}
        </Button>
    )

    async function deleteDrafts() {
        const count = draftItems.length
        const ok = await confirm(
            "These move to the Recycle Bin, where you can restore them.",
            `Delete ${count} draft ${"schedule".pluralize(count)}`,
            undefined,
            "Delete",
            { okColor: "error", okIcon: "gravity-ui:trash-bin", cancelIcon: "mdi:close-circle-outline" }
        )
        if (!ok) return
        const ids = draftItems.map((m) => m._id)
        const { failed } = await runBulk(ids, { progress: "Deleting", past: "Deleted" }, deleteDraftsBatch)
        clearGlobal(succeeded(ids, failed))
    }

    function deleteDraftsBatch(batch) {
        return Promise.allSettled(batch.map((id) => deleteDraft(id))).then((results) =>
            batch.filter((_, i) => results[i].status === "rejected")
        )
    }
}
